import { ParticipantStep } from '../../../types/v3Types';
import { getStepType, getTitle } from '../../../selectors/step';
import type { ChatStepContext } from './interfaces';

// Knowledge snippets are keyed by the program step id (source.id)
export const getChatStepContext = (
  step: ParticipantStep | null,
): ChatStepContext | undefined => {
  const stepId = step?.source?.id ?? step?.id;
  if (!stepId) {
    return undefined;
  }

  return {
    stepId,
    stepTitle: getTitle(step.source),
    stepType: getStepType(step.source),
  };
};
